import { all } from 'redux-saga/effects';
import employeePermissionSaga from './permission';
import employeeListSaga from './list';
import employeeStaffSaga from './staff';
import employeePinSaga from './pin';
import employeeRoleSaga from './role';

export default function* employeesSaga() {
  yield all([
    employeeListSaga(),
    employeePermissionSaga(),
    employeeStaffSaga(),
    employeePinSaga(),
    employeeRoleSaga(),
  ]);
}
